import classnames from "classnames";
import * as PropTypes from "prop-types";
import React from "react";

import { Error } from "../../fields/error";

import styles from "./FileSection.module.scss";

const FileSection = ({
  title,
  subtitle,
  actions,
  onClick,
  error,
  variant,
  className,
  contentList,
  children,
}) => {
  return (
    <div
      className={classnames(
        "bg-gray px-4 rounded",
        {
          "border border-danger": error,
          "py-3": variant === "user",
          "py-1": variant === "file",
        },
        className,
      )}
    >
      <div className={classnames("d-flex align-items-center")}>
        <div className="w-100 text-truncate">
          <div className={classnames(styles.title, "w-100 text-truncate")}>
            <span onClick={onClick}>{title}</span>
          </div>

          {subtitle && (
            <div
              className={classnames(
                styles.subtitle,
                "w-100 text-truncate mt-1",
              )}
            >
              {subtitle}
            </div>
          )}

          {contentList?.length > 0 &&
            contentList?.map((text, i) => (
              <div
                key={i}
                className={classnames(styles.text, "w-100 text-truncate mt-1")}
              >
                {text}
              </div>
            ))}

          {error && <Error className="mt-1">{error}</Error>}
        </div>

        {actions && (
          <div className="shrink-0 align-self-center pl-4">
            <div className="d-flex align-items-center mr-n2">{actions}</div>
          </div>
        )}
      </div>

      {children}
    </div>
  );
};

FileSection.propTypes = {
  variant: PropTypes.oneOf(["file", "user"]),
};

FileSection.defaultProps = {
  variant: "file",
};

export default FileSection;
